/*
 * @Description: 
 * @Author: zhanjunwei
 * @Date: 2025-02-28 11:09:46
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-02-28 11:11:21
 */
type EventCallback<T = any> = (data: T) => void;

class EventBus {
  private listeners: Record<string, EventCallback[]> = {};

  // 订阅事件
  on<T>(event: string, callback: EventCallback<T>) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  // 取消订阅事件
  off<T>(event: string, callback: EventCallback<T>) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(
        (listener) => listener !== callback
      );
    }
  }

  // 发布事件
  emit<T>(event: string, data: T) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((listener) => listener(data));
    }
  }
}

// 导出一个全局的 Event Bus 实例
export const eventBus = new EventBus();